exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inline[data-v-f3fbd41c] {\n  display: inline-block;\n}", ""]);

// exports
